import { createServerFn } from "@tanstack/react-start"

/**
 * Which assistant cards the signed-in organisation may use (R6.9: a feature outside the plan is
 * hidden, with no upgrade entry). Empty = the voice button is not drawn.
 */
export const getVoiceAccess = createServerFn({ method: "GET" }).handler(
  async (): Promise<{ logbook: boolean; receipts: boolean }> => {
    const [
      { getSessionUser },
      { getMainDb },
      { getOrCreateUserOrganisation },
      { getOrganisationEntitlements },
    ] = await Promise.all([
      import("@/auth/session.server"),
      import("@/db/main/db.server"),
      import("@/organisations/organisations.server"),
      import("@/billing/organisation-entitlements.server"),
    ])
    const none = { logbook: false, receipts: false }
    const user = await getSessionUser()
    if (!user) return none
    try {
      const db = getMainDb()
      const org = await getOrCreateUserOrganisation(db, user.id)
      const { features } = await getOrganisationEntitlements(db, org)
      return { logbook: features.includes("logbook"), receipts: features.includes("receipts") }
    } catch {
      return none
    }
  },
)
